import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface ActivityRowProps {
  profile_url: string;
  handle: string;
  supportDelegateEmail: string;
  text: string;
  time: string;
}

// eslint-disable-next-line camelcase
function ActivityRow({profile_url, handle, supportDelegateEmail, text, time}: ActivityRowProps): JSX.Element {
  return (
    <tr>
      <td>
        <a
          // eslint-disable-next-line camelcase
          href={profile_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {handle}
        </a>
        {supportDelegateEmail && ` (${supportDelegateEmail})`}
      </td>
      <td>{text}</td>
      <td>{time}</td>
    </tr>
  );
}

export default makeDeprecatedJadeStyleTemplate<ActivityRowProps>(ActivityRow);
